<template>
    <!--:perPageCustom="[[420, 1], [768, 2], [1024, 3]]"-->
    <div class="slider_wrapper" ref="c">
        <carousel
            :perPage="1"
            paginationColor="rgba(255,255,255,.4)"
            paginationActiveColor="#fff"
            class="carousel"
            :navigationEnabled="true"
            :navigationClickTargetSize=0
            ref="carousel"
            :loop="true"
        >
            <slide v-for="(slide, idx) in slides" :key="idx">
                <img :src="slide.imageUrl">
            </slide>
        </carousel>
    </div>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel';

export default {
    name: "Image_Slider",
    props: { slides: { default:[] } },
    components: { Carousel, Slide },
    data: () => ({
        parentVisible:false, slideImgEl:""
    }),
    created(){
        let self = this
        window.addEventListener('scroll', self.handleScroll)
    },
    methods: {
        handleScroll(){
            let self = this
            if(window.getComputedStyle(self.$refs.c.closest('.slide')).display == 'block'){
                self.parentVisible = true
                window.removeEventListener('scroll', self.handleScroll)
            } 
        }
    },
    watch:{
        'parentVisible'(){
            if(this.parentVisible) {
                setTimeout(() => this.$refs.carousel.onResize(), 100)
            }
        }
    }
}
</script>

<style lang="scss">
    .VueCarousel-slide { visibility:visible!important; flex-basis:100%!important; width:100%!important }
    .VueCarousel-navigation {
        position:absolute; top:50%; transform:translateY(-50%); height:100%; width:100%;
        
        .VueCarousel-navigation-button {
            width:0!important; height:0!important; border-style:solid!important; cursor:pointer!important; text-indent:-9999px!important; opacity:1!important;
            &.VueCarousel-navigation-prev {border-width:25px 20px 25px 0; border-color:transparent $yellow transparent transparent; left:-$space}
            &.VueCarousel-navigation-next {border-width:25px 0 25px 20px; border-color:transparent transparent transparent $yellow; right:-$space*2.2}
            &:focus { outline:none!important }
        }
    }
    .VueCarousel-pagination { display:none }
</style>